import { RecommendationPageType } from '../../config';

export const pageInfoCopies = {
  [RecommendationPageType.PUBLISHER]: {
    titleCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_PUBLISHER_TITLE',
    descriptionCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_PUBLISHER_COPY',
  },
  [RecommendationPageType.INDUSTRY]: {
    titleCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_INDUSTRY_TITLE',
    descriptionCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_INDUSTRY_COPY',
  },
  [RecommendationPageType.TOPIC]: {
    titleCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_TOPIC_TITLE',
    descriptionCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_TOPIC_COPY',
  },
  [RecommendationPageType.INSIDER]: {
    titleCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_INSIDER_TITLE',
    descriptionCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_INSIDER_COPY',
  },
  [RecommendationPageType.PRESS_REVIEW]: {
    titleCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_PRESS_REVIEW_TITLE',
    descriptionCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_PRESS_REVIEW_COPY',
  },
  [RecommendationPageType.PREMIUM]: {
    titleCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_PREMIUM_TITLE',
    descriptionCopyId: 'FOLLOWING_RECOMMENDATION_PAGE_PREMIUM_COPY',
  },
};
